module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'icon icon--' + _vm.className,
    style: ('width:' + _vm.scale + 'em;height:' + _vm.scale + 'em;'),
    attrs: {
      "aria-hidden": _vm.ariaHidden ? 'true' : 'false'
    }
  }, [_c('img', {
    style: ('width:' + _vm.scale + 'em;height:' + _vm.scale + 'em;'),
    attrs: {
      "src": 'https://static.booking.branasgruppen.se/static/svg/' + _vm.name + '.svg',
      "aria-hidden": _vm.ariaHidden ? 'true' : 'false',
      "alt": _vm.altText
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d464bfa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/Icon.vue
// module id = 898
// module chunks = 0